import { call, put, takeLatest } from "redux-saga/effects";
import { dongBoApi } from "../../../api/dong-bo/dongBoApi";
import { IDongBoHocPhiRequest } from "../../../model/request/dong-bo/IDongBoHocPhiRequest";
import { IDongBoHocPhiSinhVien } from "../../../model/respone/dong-bo/IDongBoHocPhiSinhVien";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDongBoHocPhiActionTypeIds,
  IDongBoHocPhiActionTypes,
} from "../../action-types/dong-bo/IDongBoHocPhiAction";
import { rootActions } from "../../actions/rootActions";
import { IProcessRequest } from "../../../model/request/IProcessRequest";

export function* dongBoHocPhiSaga(): any {
  yield takeLatest(eDongBoHocPhiActionTypeIds.LOAD_START, loadWorker);
  yield takeLatest(eDongBoHocPhiActionTypeIds.SYNC_START, syncWorker);
}

function* loadWorker(action: IDongBoHocPhiActionTypes): any {
  const request = action.payload as IDongBoHocPhiRequest;
  const res: IBaseRespone = yield call(dongBoApi.SelectHocPhi, request);
  if (res.is_success) {
    var data = res.data as IDongBoHocPhiSinhVien[];
    yield put(rootActions.dongBo.hocPhi.LOAD_SUCCESS(data));
  } else {
    yield put(rootActions.dongBo.hocPhi.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* syncWorker(action: IDongBoHocPhiActionTypes): any {
  const request = action.payload as IProcessRequest<IDongBoHocPhiRequest>;
  const res: IBaseRespone = yield call(dongBoApi.SyncHocPhi, request);
  if (res.is_success) {
    var data = res.data as IDongBoHocPhiSinhVien[];
    yield put(rootActions.dongBo.hocPhi.SYNC_SUCCESS(data));
  } else {
    yield put(rootActions.dongBo.hocPhi.SYNC_ERR(res.message ?? "Có lỗi"));
  }
}
